import css from '@styled-system/css';

const transition = {
  transitionProperty: 'transform, background-color, color',
  transitionDuration: '.2s',
  transitionTimingFunction: 'ease',
};

export default css({
  borderRadius: 'button.1',
  outline: 'none',
  fontSize: 'bodies.small',

  '@media (hover: hover)': {
    ':hover': transition,
  },

  ':active:not(:disabled)': {
    transform: 'scale(0.95)',
    ...transition,
  },
});
